import { useBusEmitterListener } from "../bridge";

const commentModeDiagramClickEvent = Symbol("bridge:commentModeDiagramClick");

export interface Payload {
  x: number;
  y: number;
}

export const {
  emitter: commentModeDiagramClick,
  listener: onCommentModeDiagramClick,
} = useBusEmitterListener<Payload>(commentModeDiagramClickEvent);

export function clickOnDiagram(x: number, y: number) {
  commentModeDiagramClick({ x, y });
}
